import { MenuOutlined } from "@ant-design/icons";
import { Dropdown, Image } from "antd";
import React from "react";
import { NavLink } from "react-router-dom";

import logoHeader from "../assets/icon/logo-header.svg";

import "./Header.css";

const items = [
  {
    key: "1",
    label: (
      <NavLink to="/" className="nav__link" activeclassname="active">
        Home
      </NavLink>
    ),
  },
  {
    key: "2",
    label: (
      <NavLink to="/ai" className="nav__link" activeclassname="active">
        AI & Agriculture
      </NavLink>
    ),
  },

  {
    key: "3",
    label: (
      <NavLink
        to="/achievements"
        className="nav__link"
        activeclassname="active"
      >
        Achievements
      </NavLink>
    ),
  },

  {
    key: "4",
    label: (
      <NavLink to="/music" className="nav__link" activeclassname="active">
        Music
      </NavLink>
    ),
  },
  {
    key: "5",
    label: (
      <NavLink to="/double" className="nav__link" activeclassname="active">
        Double Cannons
      </NavLink>
    ),
  },
  {
    key: "6",
    label: (
      <NavLink to="/striving" className="nav__link" activeclassname="active">
        Striving For A Change
      </NavLink>
    ),
  },
];
const Header = () => {
  return (
    <header className="header">
      <nav className="nav container">
        <a href="/">
          <img className="nav__logo" src={logoHeader} alt={`image`} />
        </a>

        <div className={`nav__menu`} id="nav-menu">
          {/* desktop */}
          <ul className="nav__list">
            {items.map((item) => (
              <li key={item.key} className="nav__item">
                {item.label}
              </li>
            ))}
          </ul>

          {/* mobile */}
          <div className="nav__list_mobile">
            <Dropdown menu={{ items }} placement="bottomRight">
              <MenuOutlined style={{ fontSize: "24px", color: "#000" }} />
            </Dropdown>
          </div>
        </div>
      </nav>
      {/* <div className="header-bottom"></div> */}
    </header>
  );
};

export default Header;
